<table class="adjustments">
	@for (adjdef of rotor.adjdef; track adjdef; let i = $index) {
		<!-- Display heading for every "display group" -->
		@if (i === 0 || adjdef.displaygroup !== rotor.adjdef[i-1].displaygroup) {
			<tr>
				<th></th>
				@for (blade of headerBlades(adjdef.displaygroup); track blade) {
					<th>{{blade.name}}</th>
				}
				@if (adjustmentSelect && adjustmentSelect.length > 1) {
					<th></th>
				}
			</tr>
		}
		@if (!excludeWts || adjdef.name !== 'WTS') {
			<tr>
				<th>
					<a [hidden]="!alternates || !alternates[i].length" (click)="adjDetail[i] = !adjDetail[i]" href="javascript:void(0)" class="nowrap">
						{{ adjdef | adjdeflabel }}
						&#9662;
					</a>
					<span [hidden]="alternates && alternates[i].length">{{ adjdef | adjdeflabel }}:</span>
				</th>
				@for (blade of filterBlades(adjdef.displaygroup); track blade; let j = $index) {
					<td>
						@if (adjustments && mode === 'h60') {
							<input [(ngModel)]="adjustments[i][j]" (keyup.enter)="enter.emit()" type="text" [name]="'adj' + i + '_' + j" class="adj-entry"
								pattern="(?:0|[lL][lLhH]?|[hH]{1,2})">
						}
						@else if (adjustments) {
							<input [(ngModel)]="adjustments[i][j]" (keyup.enter)="enter.emit()" type="number" [name]="'adj' + i + '_' + j" class="adj-entry">
						}
					</td>
				}
				@if (adjustmentSelect && adjustmentSelect.length > 1) {
					<th>
						<input [(ngModel)]="adjustmentSelect[i]" type="checkbox" [name]="'adjSelect' + i" (ngModelChange)="selectChange.emit()">
					</th>
				}
			</tr>
			@if (alternates) {
				@for (alt of alternates[i]; track alt; let altIdx = $index) {
					<tr (click)="alternateSelect.emit({ row: i, alt: altIdx })" [hidden]="!adjDetail[i]" class="alt-row">
						<th></th>
						@for (blade of filterBlades(adjdef.displaygroup); track blade; let j = $index) {
							<td>
								@if (adjustments) {
									<div>{{mode === 'h60' ? alt[j] : (alt[j] | number : "1.0-1")}}</div>
								}
							</td>
						}
						<th></th>
					</tr>
				}
			}
			<tr class="divider">
				<th></th>
			</tr>
		}
	}
</table>
